// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] + "." + {"43":"544e0c14","234":"e6ab46f7","653":"871cafe9","844":"15154f0c"}[chunkId] + ".chunk.css";
};